import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import PanelFilter from "../../../shares/PanelFilter";
import RingCard from "../../../customer-panels/create-order/RingCard";
import MuiPagination from "../../../shares/MuiPagination";
import useFetch from "../../../../context/useFetch";
import { ageList, colorList, fixNumbers } from "../../../../utils";
import ShowRingSizes from "../../../customer-panels/create-order/ShowRingSizes";
import AddRingTabThree from "../../../customer-panels/create-order/AddRingTabThree";
import PanelTable from "../../../shares/PanelTable";
import { useUserData } from "../../../../context/UserDataContext";

// import Others files

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "brand_name", name: "برند" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "seeـweights", name: "مشاهده وزن‌ها" },
  { colName: "add_ring", name: "افزودن" },
];

const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
];
const dataKey = ["code", "brand_name", "show_name", "gender", "color"];

const PTabOne = (props) => {
  const { userData } = useUserData();

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [codeFilter, setCodeFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [kindFilter, setKindFilter] = useState(null);
  const [colorFilter, setColorFilter] = useState(null);
  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "اسم",
      label_en: "name",
      state: nameFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
    {
      type: "select",
      label_fa: "نوع",
      label_en: "kind",
      state: kindFilter,
      menuItems: ageList,
    },
    {
      type: "select",
      label_fa: "رنگ",
      label_en: "color",
      state: colorFilter,
      menuItems: colorList,
    },
  ];

  
  const [ringsList, setRingsList] = useState([]);
  const GetRingsApi = useFetch({
    method: "get",
    url: `Provider_Service/${props.selectedUser?.id}/admin_get_provider_bangles`,
    params: {
      bangle_name: nameFilter,
      bangle_code: fixNumbers(codeFilter),
      bangle_brand: brandFilter,
      bangle_color: colorFilter,
      bangle_gender: kindFilter,
    },

    trigger: props.selectedUser == undefined ? false : true,
    setter: setRingsList,
    
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);
    if (state == "color") setColorFilter(e.length > 0 ? e : null);
    if (state == "kind") setKindFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    GetRingsApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setNameFilter(null);
    setBrandFilter("all");
    setKindFilter("all");
    setColorFilter("all");

    GetRingsApi.reFetch();
  };

  

  const buttonsList = [
    {
      label: "مشاهده وزن‌ها",
      component: (it) => <ShowRingSizes selectedRow={it} />,
    },
  ];
  const actionsList = [
    {
      label: "افزودن",
      component: (it) => (
        <AddRingTabThree
          producerCreateOrder
          selectedRow={it}
          selectedUser={props.selectedUser}
        />
      ),
    },
  ];

  return (
    <>
      {props.selectedUser !== undefined ? (
        <div className="mb-4">
          <span className="text-myblue-100">
            تولیدکننده انتخاب شده:{" "}
            <span className="text-gray-700">{props.selectedUser?.name}</span>
          </span>
        </div>
      ) : (
        ""
      )}
      <PanelFilter
        header="فیلتر النگوها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      {userData.job == "Admin" ? (
        <PanelTable
          header="محصولات:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={ringsList}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AccountBalanceIcon />}
        />
      ) : (
        <div className="grid md:grid-cols-4 md:gap-x-6 gap-y-4 md:gap-y-6">
          {ringsList.map((item, index) => {
            return [
              <>
                <RingCard
                producerCreateOrder
                  item={item}
                  type={item.gender == "woman" ? "زنانه" : "بچه گانه"}
                />
              </>,
            ];
          })}
        </div>
      )}

    
    </>
  );
};

export default PTabOne;
